/**
 * The id of the seeded corporate `/skill-creator` skill (a migration in `cti-conversation-service`
 * keeps it stable across environments). "Improve in chat" attaches it to the new chat.
 */
export const SKILL_CREATOR_ID = '5eed0001-0000-4000-8000-000000000003';

/** The trigger the creator row carries once its migration ran. Before that the same id is `/skill-doctor`. */
const SKILL_CREATOR_TRIGGER = 'skill-creator';

/**
 * True when `skill` is the skill creator and not the older skill doctor that held the same id. An
 * improve action is only on offer then, so a web build that reaches users before the conversation
 * service never attaches the doctor with an "Improve" prefill.
 */
export function isSkillCreatorRow<Row extends { id: string; trigger: string }>(
  skill: Row | null | undefined,
): skill is Row {
  return (
    skill?.id === SKILL_CREATOR_ID && skill.trigger === SKILL_CREATOR_TRIGGER
  );
}
